// @generated by protoc-gen-es-ns v0.0.0 with parameter "target=ts"
// @generated from file web/public/community.proto (package web.public, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { Error } from "./error_pb.js";

/**
 * @generated from message web.public.GetCommunityAccessRequest
 */
export class GetCommunityAccessRequest extends Message<GetCommunityAccessRequest> {
  constructor(data?: PartialMessage<GetCommunityAccessRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetCommunityAccessRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCommunityAccessRequest {
    return new GetCommunityAccessRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCommunityAccessRequest {
    return new GetCommunityAccessRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCommunityAccessRequest {
    return new GetCommunityAccessRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCommunityAccessRequest | PlainMessage<GetCommunityAccessRequest> | undefined, b: GetCommunityAccessRequest | PlainMessage<GetCommunityAccessRequest> | undefined): boolean {
    return proto3.util.equals(GetCommunityAccessRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.GetCommunityAccessResponse
 */
export class GetCommunityAccessResponse extends Message<GetCommunityAccessResponse> {
  /**
   * @generated from field: web.public.GetCommunityAccessResponse.Status status = 1;
   */
  status = GetCommunityAccessResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: bool allowed = 3;
   */
  allowed = false;

  constructor(data?: PartialMessage<GetCommunityAccessResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetCommunityAccessResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(GetCommunityAccessResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "allowed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCommunityAccessResponse {
    return new GetCommunityAccessResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCommunityAccessResponse {
    return new GetCommunityAccessResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCommunityAccessResponse {
    return new GetCommunityAccessResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCommunityAccessResponse | PlainMessage<GetCommunityAccessResponse> | undefined, b: GetCommunityAccessResponse | PlainMessage<GetCommunityAccessResponse> | undefined): boolean {
    return proto3.util.equals(GetCommunityAccessResponse, a, b);
  }

  static _enums: {
    Status: typeof GetCommunityAccessResponse.Status,
  };
}

export namespace GetCommunityAccessResponse {
  /**
   * @generated from enum web.public.GetCommunityAccessResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: FAILED = 1;
     */
    FAILED = 1,

    /**
     * @generated from enum value: SUCCESS = 2;
     */
    SUCCESS = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(GetCommunityAccessResponse.Status)
  proto3.util.setEnumType(GetCommunityAccessResponse.Status, "web.public.GetCommunityAccessResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "FAILED" },
    { no: 2, name: "SUCCESS" },
  ]);
}

/**
 * @generated from message web.public.ListCommunityPostsRequest
 */
export class ListCommunityPostsRequest extends Message<ListCommunityPostsRequest> {
  /**
   * @generated from field: optional string token = 1;
   */
  token?: string;

  /**
   * @generated from field: uint32 page = 2;
   */
  page = 0;

  /**
   * @generated from field: web.public.ListCommunityPostsRequest.SortMethod sort_method = 3;
   */
  sortMethod = ListCommunityPostsRequest.SortMethod.DEFAULT;

  /**
   * @generated from field: string query = 4;
   */
  query = "";

  constructor(data?: PartialMessage<ListCommunityPostsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ListCommunityPostsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "page", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "sort_method", kind: "enum", T: proto3.getEnumType(ListCommunityPostsRequest.SortMethod) },
    { no: 4, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCommunityPostsRequest {
    return new ListCommunityPostsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCommunityPostsRequest {
    return new ListCommunityPostsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCommunityPostsRequest {
    return new ListCommunityPostsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListCommunityPostsRequest | PlainMessage<ListCommunityPostsRequest> | undefined, b: ListCommunityPostsRequest | PlainMessage<ListCommunityPostsRequest> | undefined): boolean {
    return proto3.util.equals(ListCommunityPostsRequest, a, b);
  }

  static _enums: {
    SortMethod: typeof ListCommunityPostsRequest.SortMethod,
  };
}

export namespace ListCommunityPostsRequest {
  /**
   * @generated from enum web.public.ListCommunityPostsRequest.SortMethod
   */
  export enum SortMethod {
    /**
     * @generated from enum value: DEFAULT = 0;
     */
    DEFAULT = 0,

    /**
     * @generated from enum value: VOTES = 1;
     */
    VOTES = 1,

    /**
     * @generated from enum value: RECENT = 2;
     */
    RECENT = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ListCommunityPostsRequest.SortMethod)
  proto3.util.setEnumType(ListCommunityPostsRequest.SortMethod, "web.public.ListCommunityPostsRequest.SortMethod", [
    { no: 0, name: "DEFAULT" },
    { no: 1, name: "VOTES" },
    { no: 2, name: "RECENT" },
  ]);
}

/**
 * @generated from message web.public.ListCommunityPostsResponse
 */
export class ListCommunityPostsResponse extends Message<ListCommunityPostsResponse> {
  /**
   * @generated from field: web.public.ListCommunityPostsResponse.Status status = 1;
   */
  status = ListCommunityPostsResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated web.public.CommunityPost posts = 3;
   */
  posts: CommunityPost[] = [];

  /**
   * @generated from field: map<string, web.public.CommunityPost.Vote> user_vote_by_post_token = 4;
   */
  userVoteByPostToken: { [key: string]: CommunityPost.Vote } = {};

  /**
   * @generated from field: map<string, bool> user_is_following_by_post_token = 5;
   */
  userIsFollowingByPostToken: { [key: string]: boolean } = {};

  constructor(data?: PartialMessage<ListCommunityPostsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ListCommunityPostsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ListCommunityPostsResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "posts", kind: "message", T: CommunityPost, repeated: true },
    { no: 4, name: "user_vote_by_post_token", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "enum", T: proto3.getEnumType(CommunityPost.Vote)} },
    { no: 5, name: "user_is_following_by_post_token", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 8 /* ScalarType.BOOL */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCommunityPostsResponse {
    return new ListCommunityPostsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCommunityPostsResponse {
    return new ListCommunityPostsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCommunityPostsResponse {
    return new ListCommunityPostsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListCommunityPostsResponse | PlainMessage<ListCommunityPostsResponse> | undefined, b: ListCommunityPostsResponse | PlainMessage<ListCommunityPostsResponse> | undefined): boolean {
    return proto3.util.equals(ListCommunityPostsResponse, a, b);
  }

  static _enums: {
    Status: typeof ListCommunityPostsResponse.Status,
  };
}

export namespace ListCommunityPostsResponse {
  /**
   * @generated from enum web.public.ListCommunityPostsResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: FAILED = 1;
     */
    FAILED = 1,

    /**
     * @generated from enum value: SUCCESS = 2;
     */
    SUCCESS = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ListCommunityPostsResponse.Status)
  proto3.util.setEnumType(ListCommunityPostsResponse.Status, "web.public.ListCommunityPostsResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "FAILED" },
    { no: 2, name: "SUCCESS" },
  ]);
}

/**
 * @generated from message web.public.GetCommunityPostRequest
 */
export class GetCommunityPostRequest extends Message<GetCommunityPostRequest> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  constructor(data?: PartialMessage<GetCommunityPostRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetCommunityPostRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCommunityPostRequest {
    return new GetCommunityPostRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCommunityPostRequest {
    return new GetCommunityPostRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCommunityPostRequest {
    return new GetCommunityPostRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCommunityPostRequest | PlainMessage<GetCommunityPostRequest> | undefined, b: GetCommunityPostRequest | PlainMessage<GetCommunityPostRequest> | undefined): boolean {
    return proto3.util.equals(GetCommunityPostRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.GetCommunityPostResponse
 */
export class GetCommunityPostResponse extends Message<GetCommunityPostResponse> {
  /**
   * @generated from field: web.public.GetCommunityPostResponse.Status status = 1;
   */
  status = GetCommunityPostResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.CommunityPost post = 3;
   */
  post?: CommunityPost;

  /**
   * @generated from field: repeated web.public.CommunityPost replies = 4;
   */
  replies: CommunityPost[] = [];

  /**
   * @generated from field: map<string, web.public.CommunityPost.Vote> user_vote_by_post_token = 5;
   */
  userVoteByPostToken: { [key: string]: CommunityPost.Vote } = {};

  /**
   * @generated from field: map<string, bool> user_is_following_by_post_token = 6;
   */
  userIsFollowingByPostToken: { [key: string]: boolean } = {};

  constructor(data?: PartialMessage<GetCommunityPostResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetCommunityPostResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(GetCommunityPostResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "post", kind: "message", T: CommunityPost },
    { no: 4, name: "replies", kind: "message", T: CommunityPost, repeated: true },
    { no: 5, name: "user_vote_by_post_token", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "enum", T: proto3.getEnumType(CommunityPost.Vote)} },
    { no: 6, name: "user_is_following_by_post_token", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 8 /* ScalarType.BOOL */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCommunityPostResponse {
    return new GetCommunityPostResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCommunityPostResponse {
    return new GetCommunityPostResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCommunityPostResponse {
    return new GetCommunityPostResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCommunityPostResponse | PlainMessage<GetCommunityPostResponse> | undefined, b: GetCommunityPostResponse | PlainMessage<GetCommunityPostResponse> | undefined): boolean {
    return proto3.util.equals(GetCommunityPostResponse, a, b);
  }

  static _enums: {
    Status: typeof GetCommunityPostResponse.Status,
  };
}

export namespace GetCommunityPostResponse {
  /**
   * @generated from enum web.public.GetCommunityPostResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: FAILED = 1;
     */
    FAILED = 1,

    /**
     * @generated from enum value: SUCCESS = 2;
     */
    SUCCESS = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(GetCommunityPostResponse.Status)
  proto3.util.setEnumType(GetCommunityPostResponse.Status, "web.public.GetCommunityPostResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "FAILED" },
    { no: 2, name: "SUCCESS" },
  ]);
}

/**
 * @generated from message web.public.CreateCommunityPostRequest
 */
export class CreateCommunityPostRequest extends Message<CreateCommunityPostRequest> {
  /**
   * @generated from field: string title = 1;
   */
  title = "";

  /**
   * @generated from field: string body_md = 2;
   */
  bodyMd = "";

  /**
   * @generated from field: string parent_token = 3;
   */
  parentToken = "";

  /**
   * @generated from field: bool anonymous = 4;
   */
  anonymous = false;

  /**
   * @generated from field: bool show_score = 5;
   */
  showScore = false;

  /**
   * @generated from field: repeated string tag_tokens = 6;
   */
  tagTokens: string[] = [];

  constructor(data?: PartialMessage<CreateCommunityPostRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CreateCommunityPostRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "body_md", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "parent_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "anonymous", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "show_score", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "tag_tokens", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCommunityPostRequest {
    return new CreateCommunityPostRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCommunityPostRequest {
    return new CreateCommunityPostRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCommunityPostRequest {
    return new CreateCommunityPostRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCommunityPostRequest | PlainMessage<CreateCommunityPostRequest> | undefined, b: CreateCommunityPostRequest | PlainMessage<CreateCommunityPostRequest> | undefined): boolean {
    return proto3.util.equals(CreateCommunityPostRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.CreateCommunityPostResponse
 */
export class CreateCommunityPostResponse extends Message<CreateCommunityPostResponse> {
  /**
   * @generated from field: web.public.CreateCommunityPostResponse.Status status = 1;
   */
  status = CreateCommunityPostResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.CommunityPost post = 3;
   */
  post?: CommunityPost;

  /**
   * @generated from field: web.public.CommunityPost.Vote user_vote = 4;
   */
  userVote = CommunityPost.Vote.NONE;

  /**
   * @generated from field: bool user_is_following = 5;
   */
  userIsFollowing = false;

  constructor(data?: PartialMessage<CreateCommunityPostResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CreateCommunityPostResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(CreateCommunityPostResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "post", kind: "message", T: CommunityPost },
    { no: 4, name: "user_vote", kind: "enum", T: proto3.getEnumType(CommunityPost.Vote) },
    { no: 5, name: "user_is_following", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCommunityPostResponse {
    return new CreateCommunityPostResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCommunityPostResponse {
    return new CreateCommunityPostResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCommunityPostResponse {
    return new CreateCommunityPostResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCommunityPostResponse | PlainMessage<CreateCommunityPostResponse> | undefined, b: CreateCommunityPostResponse | PlainMessage<CreateCommunityPostResponse> | undefined): boolean {
    return proto3.util.equals(CreateCommunityPostResponse, a, b);
  }

  static _enums: {
    Status: typeof CreateCommunityPostResponse.Status,
  };
}

export namespace CreateCommunityPostResponse {
  /**
   * @generated from enum web.public.CreateCommunityPostResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: FAILED = 1;
     */
    FAILED = 1,

    /**
     * @generated from enum value: SUCCESS = 2;
     */
    SUCCESS = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(CreateCommunityPostResponse.Status)
  proto3.util.setEnumType(CreateCommunityPostResponse.Status, "web.public.CreateCommunityPostResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "FAILED" },
    { no: 2, name: "SUCCESS" },
  ]);
}

/**
 * @generated from message web.public.FollowCommunityPostRequest
 */
export class FollowCommunityPostRequest extends Message<FollowCommunityPostRequest> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  constructor(data?: PartialMessage<FollowCommunityPostRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.FollowCommunityPostRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FollowCommunityPostRequest {
    return new FollowCommunityPostRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FollowCommunityPostRequest {
    return new FollowCommunityPostRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FollowCommunityPostRequest {
    return new FollowCommunityPostRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FollowCommunityPostRequest | PlainMessage<FollowCommunityPostRequest> | undefined, b: FollowCommunityPostRequest | PlainMessage<FollowCommunityPostRequest> | undefined): boolean {
    return proto3.util.equals(FollowCommunityPostRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.FollowCommunityPostResponse
 */
export class FollowCommunityPostResponse extends Message<FollowCommunityPostResponse> {
  /**
   * @generated from field: web.public.FollowCommunityPostResponse.Status status = 1;
   */
  status = FollowCommunityPostResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  constructor(data?: PartialMessage<FollowCommunityPostResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.FollowCommunityPostResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(FollowCommunityPostResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FollowCommunityPostResponse {
    return new FollowCommunityPostResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FollowCommunityPostResponse {
    return new FollowCommunityPostResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FollowCommunityPostResponse {
    return new FollowCommunityPostResponse().fromJsonString(jsonString, options);
  }

  static equals(a: FollowCommunityPostResponse | PlainMessage<FollowCommunityPostResponse> | undefined, b: FollowCommunityPostResponse | PlainMessage<FollowCommunityPostResponse> | undefined): boolean {
    return proto3.util.equals(FollowCommunityPostResponse, a, b);
  }

  static _enums: {
    Status: typeof FollowCommunityPostResponse.Status,
  };
}

export namespace FollowCommunityPostResponse {
  /**
   * @generated from enum web.public.FollowCommunityPostResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: FAILED = 1;
     */
    FAILED = 1,

    /**
     * @generated from enum value: SUCCESS = 2;
     */
    SUCCESS = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(FollowCommunityPostResponse.Status)
  proto3.util.setEnumType(FollowCommunityPostResponse.Status, "web.public.FollowCommunityPostResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "FAILED" },
    { no: 2, name: "SUCCESS" },
  ]);
}

/**
 * @generated from message web.public.UnfollowCommunityPostRequest
 */
export class UnfollowCommunityPostRequest extends Message<UnfollowCommunityPostRequest> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  constructor(data?: PartialMessage<UnfollowCommunityPostRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UnfollowCommunityPostRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnfollowCommunityPostRequest {
    return new UnfollowCommunityPostRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnfollowCommunityPostRequest {
    return new UnfollowCommunityPostRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnfollowCommunityPostRequest {
    return new UnfollowCommunityPostRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UnfollowCommunityPostRequest | PlainMessage<UnfollowCommunityPostRequest> | undefined, b: UnfollowCommunityPostRequest | PlainMessage<UnfollowCommunityPostRequest> | undefined): boolean {
    return proto3.util.equals(UnfollowCommunityPostRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.UnfollowCommunityPostResponse
 */
export class UnfollowCommunityPostResponse extends Message<UnfollowCommunityPostResponse> {
  /**
   * @generated from field: web.public.UnfollowCommunityPostResponse.Status status = 1;
   */
  status = UnfollowCommunityPostResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  constructor(data?: PartialMessage<UnfollowCommunityPostResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UnfollowCommunityPostResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(UnfollowCommunityPostResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnfollowCommunityPostResponse {
    return new UnfollowCommunityPostResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnfollowCommunityPostResponse {
    return new UnfollowCommunityPostResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnfollowCommunityPostResponse {
    return new UnfollowCommunityPostResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UnfollowCommunityPostResponse | PlainMessage<UnfollowCommunityPostResponse> | undefined, b: UnfollowCommunityPostResponse | PlainMessage<UnfollowCommunityPostResponse> | undefined): boolean {
    return proto3.util.equals(UnfollowCommunityPostResponse, a, b);
  }

  static _enums: {
    Status: typeof UnfollowCommunityPostResponse.Status,
  };
}

export namespace UnfollowCommunityPostResponse {
  /**
   * @generated from enum web.public.UnfollowCommunityPostResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: FAILED = 1;
     */
    FAILED = 1,

    /**
     * @generated from enum value: SUCCESS = 2;
     */
    SUCCESS = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(UnfollowCommunityPostResponse.Status)
  proto3.util.setEnumType(UnfollowCommunityPostResponse.Status, "web.public.UnfollowCommunityPostResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "FAILED" },
    { no: 2, name: "SUCCESS" },
  ]);
}

/**
 * @generated from message web.public.ViewCommunityPostRequest
 */
export class ViewCommunityPostRequest extends Message<ViewCommunityPostRequest> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  constructor(data?: PartialMessage<ViewCommunityPostRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ViewCommunityPostRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ViewCommunityPostRequest {
    return new ViewCommunityPostRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ViewCommunityPostRequest {
    return new ViewCommunityPostRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ViewCommunityPostRequest {
    return new ViewCommunityPostRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ViewCommunityPostRequest | PlainMessage<ViewCommunityPostRequest> | undefined, b: ViewCommunityPostRequest | PlainMessage<ViewCommunityPostRequest> | undefined): boolean {
    return proto3.util.equals(ViewCommunityPostRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.ViewCommunityPostResponse
 */
export class ViewCommunityPostResponse extends Message<ViewCommunityPostResponse> {
  /**
   * @generated from field: web.public.ViewCommunityPostResponse.Status status = 1;
   */
  status = ViewCommunityPostResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  constructor(data?: PartialMessage<ViewCommunityPostResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ViewCommunityPostResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ViewCommunityPostResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ViewCommunityPostResponse {
    return new ViewCommunityPostResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ViewCommunityPostResponse {
    return new ViewCommunityPostResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ViewCommunityPostResponse {
    return new ViewCommunityPostResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ViewCommunityPostResponse | PlainMessage<ViewCommunityPostResponse> | undefined, b: ViewCommunityPostResponse | PlainMessage<ViewCommunityPostResponse> | undefined): boolean {
    return proto3.util.equals(ViewCommunityPostResponse, a, b);
  }

  static _enums: {
    Status: typeof ViewCommunityPostResponse.Status,
  };
}

export namespace ViewCommunityPostResponse {
  /**
   * @generated from enum web.public.ViewCommunityPostResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: FAILED = 1;
     */
    FAILED = 1,

    /**
     * @generated from enum value: SUCCESS = 2;
     */
    SUCCESS = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ViewCommunityPostResponse.Status)
  proto3.util.setEnumType(ViewCommunityPostResponse.Status, "web.public.ViewCommunityPostResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "FAILED" },
    { no: 2, name: "SUCCESS" },
  ]);
}

/**
 * @generated from message web.public.GetCommunityProfileRequest
 */
export class GetCommunityProfileRequest extends Message<GetCommunityProfileRequest> {
  /**
   * Provide current user's profile by default
   *
   * @generated from field: optional string token = 1;
   */
  token?: string;

  constructor(data?: PartialMessage<GetCommunityProfileRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetCommunityProfileRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCommunityProfileRequest {
    return new GetCommunityProfileRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCommunityProfileRequest {
    return new GetCommunityProfileRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCommunityProfileRequest {
    return new GetCommunityProfileRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCommunityProfileRequest | PlainMessage<GetCommunityProfileRequest> | undefined, b: GetCommunityProfileRequest | PlainMessage<GetCommunityProfileRequest> | undefined): boolean {
    return proto3.util.equals(GetCommunityProfileRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.GetCommunityProfileResponse
 */
export class GetCommunityProfileResponse extends Message<GetCommunityProfileResponse> {
  /**
   * @generated from field: web.public.GetCommunityProfileResponse.Status status = 1;
   */
  status = GetCommunityProfileResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.CommunityProfile profile = 3;
   */
  profile?: CommunityProfile;

  constructor(data?: PartialMessage<GetCommunityProfileResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetCommunityProfileResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(GetCommunityProfileResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "profile", kind: "message", T: CommunityProfile },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCommunityProfileResponse {
    return new GetCommunityProfileResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCommunityProfileResponse {
    return new GetCommunityProfileResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCommunityProfileResponse {
    return new GetCommunityProfileResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCommunityProfileResponse | PlainMessage<GetCommunityProfileResponse> | undefined, b: GetCommunityProfileResponse | PlainMessage<GetCommunityProfileResponse> | undefined): boolean {
    return proto3.util.equals(GetCommunityProfileResponse, a, b);
  }

  static _enums: {
    Status: typeof GetCommunityProfileResponse.Status,
  };
}

export namespace GetCommunityProfileResponse {
  /**
   * @generated from enum web.public.GetCommunityProfileResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: FAILED = 1;
     */
    FAILED = 1,

    /**
     * @generated from enum value: SUCCESS = 2;
     */
    SUCCESS = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(GetCommunityProfileResponse.Status)
  proto3.util.setEnumType(GetCommunityProfileResponse.Status, "web.public.GetCommunityProfileResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "FAILED" },
    { no: 2, name: "SUCCESS" },
  ]);
}

/**
 * @generated from message web.public.VoteRequest
 */
export class VoteRequest extends Message<VoteRequest> {
  /**
   * @generated from field: string post_token = 1;
   */
  postToken = "";

  /**
   * @generated from field: web.public.CommunityPost.Vote vote_type = 2;
   */
  voteType = CommunityPost.Vote.NONE;

  constructor(data?: PartialMessage<VoteRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.VoteRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "post_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "vote_type", kind: "enum", T: proto3.getEnumType(CommunityPost.Vote) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VoteRequest {
    return new VoteRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VoteRequest {
    return new VoteRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VoteRequest {
    return new VoteRequest().fromJsonString(jsonString, options);
  }

  static equals(a: VoteRequest | PlainMessage<VoteRequest> | undefined, b: VoteRequest | PlainMessage<VoteRequest> | undefined): boolean {
    return proto3.util.equals(VoteRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.VoteResponse
 */
export class VoteResponse extends Message<VoteResponse> {
  /**
   * @generated from field: web.public.VoteResponse.Status status = 1;
   */
  status = VoteResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  constructor(data?: PartialMessage<VoteResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.VoteResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(VoteResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VoteResponse {
    return new VoteResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VoteResponse {
    return new VoteResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VoteResponse {
    return new VoteResponse().fromJsonString(jsonString, options);
  }

  static equals(a: VoteResponse | PlainMessage<VoteResponse> | undefined, b: VoteResponse | PlainMessage<VoteResponse> | undefined): boolean {
    return proto3.util.equals(VoteResponse, a, b);
  }

  static _enums: {
    Status: typeof VoteResponse.Status,
  };
}

export namespace VoteResponse {
  /**
   * @generated from enum web.public.VoteResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: FAILED = 1;
     */
    FAILED = 1,

    /**
     * @generated from enum value: SUCCESS = 2;
     */
    SUCCESS = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(VoteResponse.Status)
  proto3.util.setEnumType(VoteResponse.Status, "web.public.VoteResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "FAILED" },
    { no: 2, name: "SUCCESS" },
  ]);
}

/**
 * @generated from message web.public.CommunityPost
 */
export class CommunityPost extends Message<CommunityPost> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  /**
   * @generated from field: web.public.CommunityPost.Profile profile = 2;
   */
  profile?: CommunityPost.Profile;

  /**
   * Root post only
   *
   * @generated from field: string title = 3;
   */
  title = "";

  /**
   * @generated from field: string body_md = 4;
   */
  bodyMd = "";

  /**
   * @generated from field: uint32 follow_count = 5;
   */
  followCount = 0;

  /**
   * @generated from field: repeated string reply_tokens = 6;
   */
  replyTokens: string[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp posted_at = 7;
   */
  postedAt?: Timestamp;

  /**
   * @generated from field: bool is_pinned = 10;
   */
  isPinned = false;

  /**
   * @generated from field: string parent_token = 11;
   */
  parentToken = "";

  /**
   * @generated from field: uint32 upvote_count = 12;
   */
  upvoteCount = 0;

  /**
   * @generated from field: uint32 downvote_count = 13;
   */
  downvoteCount = 0;

  /**
   * @generated from field: repeated string tag_tokens = 14;
   */
  tagTokens: string[] = [];

  /**
   * @generated from field: bool active = 15;
   */
  active = false;

  constructor(data?: PartialMessage<CommunityPost>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CommunityPost";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "profile", kind: "message", T: CommunityPost.Profile },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "body_md", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "follow_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 6, name: "reply_tokens", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "posted_at", kind: "message", T: Timestamp },
    { no: 10, name: "is_pinned", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "parent_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "upvote_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 13, name: "downvote_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 14, name: "tag_tokens", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 15, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CommunityPost {
    return new CommunityPost().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CommunityPost {
    return new CommunityPost().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CommunityPost {
    return new CommunityPost().fromJsonString(jsonString, options);
  }

  static equals(a: CommunityPost | PlainMessage<CommunityPost> | undefined, b: CommunityPost | PlainMessage<CommunityPost> | undefined): boolean {
    return proto3.util.equals(CommunityPost, a, b);
  }

  static _enums: {
    Vote: typeof CommunityPost.Vote,
  };
}

export namespace CommunityPost {
  /**
   * @generated from enum web.public.CommunityPost.Vote
   */
  export enum Vote {
    /**
     * @generated from enum value: NONE = 0;
     */
    NONE = 0,

    /**
     * @generated from enum value: UPVOTE = 1;
     */
    UPVOTE = 1,

    /**
     * @generated from enum value: DOWNVOTE = 2;
     */
    DOWNVOTE = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(CommunityPost.Vote)
  proto3.util.setEnumType(CommunityPost.Vote, "web.public.CommunityPost.Vote", [
    { no: 0, name: "NONE" },
    { no: 1, name: "UPVOTE" },
    { no: 2, name: "DOWNVOTE" },
  ]);
}

export namespace CommunityPost {
  /**
   * This is a profile summary, CommunityProfile may include a bio and other
   * profile info in the future that we don't want to include with every post
   *
   * @generated from message web.public.CommunityPost.Profile
   */
  export class Profile extends Message<CommunityPost.Profile> {
    /**
     * @generated from field: string token = 1;
     */
    token = "";

    /**
     * @generated from field: string display_name = 2;
     */
    displayName = "";

    /**
     * @generated from field: uint32 credit_score = 3;
     */
    creditScore = 0;

    /**
     * @generated from field: bool is_admin = 4;
     */
    isAdmin = false;

    constructor(data?: PartialMessage<CommunityPost.Profile>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.CommunityPost.Profile";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 3, name: "credit_score", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 4, name: "is_admin", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CommunityPost.Profile {
      return new CommunityPost.Profile().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CommunityPost.Profile {
      return new CommunityPost.Profile().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CommunityPost.Profile {
      return new CommunityPost.Profile().fromJsonString(jsonString, options);
    }

    static equals(a: CommunityPost.Profile | PlainMessage<CommunityPost.Profile> | undefined, b: CommunityPost.Profile | PlainMessage<CommunityPost.Profile> | undefined): boolean {
      return proto3.util.equals(CommunityPost.Profile, a, b);
    }

    static _enums: {
    };
  }
}

/**
 * @generated from message web.public.CommunityProfile
 */
export class CommunityProfile extends Message<CommunityProfile> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  /**
   * @generated from field: string display_name = 2;
   */
  displayName = "";

  /**
   * @generated from field: uint32 credit_score = 3;
   */
  creditScore = 0;

  /**
   * @generated from field: bool show_score = 4;
   */
  showScore = false;

  /**
   * @generated from field: bool is_admin = 5;
   */
  isAdmin = false;

  constructor(data?: PartialMessage<CommunityProfile>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CommunityProfile";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "credit_score", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "show_score", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "is_admin", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CommunityProfile {
    return new CommunityProfile().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CommunityProfile {
    return new CommunityProfile().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CommunityProfile {
    return new CommunityProfile().fromJsonString(jsonString, options);
  }

  static equals(a: CommunityProfile | PlainMessage<CommunityProfile> | undefined, b: CommunityProfile | PlainMessage<CommunityProfile> | undefined): boolean {
    return proto3.util.equals(CommunityProfile, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.CommunityTag
 */
export class CommunityTag extends Message<CommunityTag> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string color = 3;
   */
  color = "";

  constructor(data?: PartialMessage<CommunityTag>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CommunityTag";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CommunityTag {
    return new CommunityTag().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CommunityTag {
    return new CommunityTag().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CommunityTag {
    return new CommunityTag().fromJsonString(jsonString, options);
  }

  static equals(a: CommunityTag | PlainMessage<CommunityTag> | undefined, b: CommunityTag | PlainMessage<CommunityTag> | undefined): boolean {
    return proto3.util.equals(CommunityTag, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.ListCommunityTagsRequest
 */
export class ListCommunityTagsRequest extends Message<ListCommunityTagsRequest> {
  constructor(data?: PartialMessage<ListCommunityTagsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ListCommunityTagsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCommunityTagsRequest {
    return new ListCommunityTagsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCommunityTagsRequest {
    return new ListCommunityTagsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCommunityTagsRequest {
    return new ListCommunityTagsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListCommunityTagsRequest | PlainMessage<ListCommunityTagsRequest> | undefined, b: ListCommunityTagsRequest | PlainMessage<ListCommunityTagsRequest> | undefined): boolean {
    return proto3.util.equals(ListCommunityTagsRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.ListCommunityTagsResponse
 */
export class ListCommunityTagsResponse extends Message<ListCommunityTagsResponse> {
  /**
   * @generated from field: web.public.ListCommunityTagsResponse.Status status = 1;
   */
  status = ListCommunityTagsResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated web.public.CommunityTag tags = 3;
   */
  tags: CommunityTag[] = [];

  constructor(data?: PartialMessage<ListCommunityTagsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ListCommunityTagsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ListCommunityTagsResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "tags", kind: "message", T: CommunityTag, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCommunityTagsResponse {
    return new ListCommunityTagsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCommunityTagsResponse {
    return new ListCommunityTagsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCommunityTagsResponse {
    return new ListCommunityTagsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListCommunityTagsResponse | PlainMessage<ListCommunityTagsResponse> | undefined, b: ListCommunityTagsResponse | PlainMessage<ListCommunityTagsResponse> | undefined): boolean {
    return proto3.util.equals(ListCommunityTagsResponse, a, b);
  }

  static _enums: {
    Status: typeof ListCommunityTagsResponse.Status,
  };
}

export namespace ListCommunityTagsResponse {
  /**
   * @generated from enum web.public.ListCommunityTagsResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: FAILED = 1;
     */
    FAILED = 1,

    /**
     * @generated from enum value: SUCCESS = 2;
     */
    SUCCESS = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ListCommunityTagsResponse.Status)
  proto3.util.setEnumType(ListCommunityTagsResponse.Status, "web.public.ListCommunityTagsResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "FAILED" },
    { no: 2, name: "SUCCESS" },
  ]);
}

